<a [routerLink]="promo.carrousel_url" [queryParams]="{ id: promo.name }" target="_blank">
    <div class="as-pointer as-product-promo" [ngStyle]="{'background-image': 'url('+ promo?.route +')'}"></div>
</a>